import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";

const SystemIntegrationPage: React.FC = () => {
  return <ServicePageTemplate slug="system-integration" />;
};

export default SystemIntegrationPage;
